export const matchHover = window.matchMedia('only screen and (hover: hover)');
export const matchBelowLg = window.matchMedia('only screen and (max-width: 1023px)');
// export const matchLg = window.matchMedia('only screen and (max-width: 1024px)');